import React, { useState } from 'react';
import cN from 'classnames';
import styles from '@components/SearchPage/Filters/styles.module.scss';

import { Star } from '@components/Common/Icons';

export interface StarItemProps {
    starNumber: number; // 星級
    isActive: Boolean;
}

const StarItem: React.FC<StarItemProps> = (props) => {
    const { starNumber, isActive } = props;
    return (
        <div className={cN(styles.Item, { active: isActive })}>
            <span>{starNumber}</span>
            <Star fill={isActive ? '#f03742' : '#bbb'} />
        </div>
    );
};
interface I_HotelStarHandler {
    handleHotelStar: (
        filterKey: 'selectedHotelLevels',
        checkedValue: string | number
    ) => () => void;
    isCheck: boolean; // 這邊是否點過判斷變布林值
    stars: number;
}

const HotelStar: React.FC<I_HotelStarHandler> = (props) => {
    const { handleHotelStar, stars, isCheck } = props;
    const [starActive, setStarActive] = useState(isCheck); //setStarActive 元件自身的狀態這邊不用以props為準，之後改可以把callback拿掉
    function clickHandler(i: number) {
        // setStateList((preState) => !preState);
        handleHotelStar('selectedHotelLevels', i.toString())(); // 這邊不好理解看是否要重整這個元件
    }
    return (
        <div onClick={() => clickHandler(stars)} key={`${stars}star`}>
            <StarItem starNumber={stars} isActive={isCheck} />
        </div>
    );
};

export { HotelStar };
